package one.healthium.ricediet.providers

import dev.gitlive.firebase.remoteconfig.FirebaseRemoteConfig
import dev.gitlive.firebase.remoteconfig.get
import one.healthium.domain.paywall.PaywallIdProvider

class AppPaywallIdProvider(
    private val remoteConfig: FirebaseRemoteConfig,
) : PaywallIdProvider {

    override suspend fun getPaywallId(): String {
        runCatching { remoteConfig.fetchAndActivate() }
        val remotePaywallId = remoteConfig.get<String?>("paywall")
        return if (!remotePaywallId.isNullOrEmpty()) {
            remotePaywallId
        } else {
            "v101_noskip"
        }
    }
}
